// src/config.js
const config = {
    //hostName: "https://ucgame.local",
    hostName: "https://game.eek.ee",
    apiVersion: "v1",
    // add other global constants here
    googleApiKey: "AIzaSyCOKydIQF7Ga4kVs0j-pnPBihSGUbSMbN8", 
    imagesHost: "https://game2.eek.ee",
  };
  
  export default config;
